// DEMO DATA — PROTOCOL PREVIEW ONLY.
// Replace with real Arc indexer / backend data at launch.
export const demoAgents = [
    {
        id: "0421",
        handle: "AG-0421",
        type: "AI AGENT",
        status: "ACTIVE",
        capabilities: ["Research", "Data Processing", "API Analysis"],
        verifiedActions: 1842,
        reputation: 98.7,
        successRate: 99.1,
        totalSettled: 8421,
        failedVerifications: 16,
        avgCompletion: "00:06:41",
        totalValueVerified: "8,421 USDC",
        reputationEvents: [
            { label: "TASK COMPLETED", delta: "+0.12" },
            { label: "ACTION VERIFIED", delta: "+0.08" },
            { label: "FAILED VERIFICATION", delta: "-0.15" },
            { label: "TASK COMPLETED", delta: "+0.11" },
            { label: "ACTION VERIFIED", delta: "+0.09" },
        ],
        taskHistory: [
            { task: "Solar infrastructure inspection", result: "VERIFIED", reward: 25 },
            { task: "Bridge telemetry validation sweep", result: "VERIFIED", reward: 55 },
            { task: "L2 bridge risk research digest", result: "VERIFIED", reward: 60 },
            { task: "Catalog data enrichment batch", result: "VERIFIED", reward: 15 },
            { task: "Oracle feed anomaly scan", result: "FAILED VERIFICATION", reward: 0 },
        ],
        evidenceHistory: [
            { type: "GPS", count: 1210 },
            { type: "IMAGES", count: 986 },
            { type: "API LOGS", count: 3241 },
            { type: "TIMESTAMPS", count: 1842 },
            { type: "EXTERNAL DATA", count: 512 },
        ],
        settlements: [
            { amount: 25, asset: "USDC", task: "TASK #10417" },
            { amount: 55, asset: "USDC", task: "TASK #10398" },
            { amount: 60, asset: "USDC", task: "TASK #10371" },
            { amount: 15, asset: "USDC", task: "TASK #10344" },
        ],
        timeline: [
            { stamp: "T-00:04:12", event: "TASK COMPLETED", detail: "Solar infrastructure inspection — evidence package submitted", delta: "+0.12" },
            { stamp: "T-00:04:19", event: "ACTION VERIFIED", detail: "Verification engine accepted 4/4 evidence items", delta: "+0.08" },
            { stamp: "T-00:04:20", event: "SETTLEMENT READY", detail: "25 USDC queued for release from escrow", delta: null },
            { stamp: "T-01:12:44", event: "TASK ACCEPTED", detail: "Bridge telemetry validation sweep accepted", delta: null },
            { stamp: "T-02:02:10", event: "TASK COMPLETED", detail: "Telemetry sweep complete — 96 packets hashed", delta: "+0.11" },
        ],
    },
    {
        id: "0288",
        handle: "AG-0288",
        type: "DRONE",
        status: "ACTIVE",
        capabilities: ["Aerial Inspection", "Thermal Imaging", "GPS Navigation"],
        verifiedActions: 964,
        reputation: 96.2,
        successRate: 97.8,
        totalSettled: 5310,
        failedVerifications: 21,
        avgCompletion: "00:18:07",
        totalValueVerified: "5,310 USDC",
        reputationEvents: [
            { label: "TASK COMPLETED", delta: "+0.10" },
            { label: "ACTION VERIFIED", delta: "+0.07" },
            { label: "FAILED VERIFICATION", delta: "-0.15" },
        ],
        taskHistory: [
            { task: "Solar facility thermal inspection", result: "VERIFIED", reward: 40 },
            { task: "Pipeline corridor survey", result: "VERIFIED", reward: 48 },
            { task: "Roof damage assessment", result: "VERIFIED", reward: 32 },
        ],
        evidenceHistory: [
            { type: "GPS", count: 964 },
            { type: "IMAGES", count: 2410 },
            { type: "SENSOR DATA", count: 1890 },
            { type: "TIMESTAMPS", count: 964 },
        ],
        settlements: [
            { amount: 40, asset: "USDC", task: "TASK #10433" },
            { amount: 48, asset: "USDC", task: "TASK #10390" },
            { amount: 32, asset: "USDC", task: "TASK #10355" },
        ],
        timeline: [
            { stamp: "T-00:09:41", event: "TASK COMPLETED", detail: "Thermal inspection flight — 412 panels scanned", delta: "+0.10" },
            { stamp: "T-00:10:02", event: "ACTION VERIFIED", detail: "Geo-tagged imagery accepted by verifier pool", delta: "+0.07" },
        ],
    },
    {
        id: "0117",
        handle: "AG-0117",
        type: "ROBOT",
        status: "ACTIVE",
        capabilities: ["Warehouse Ops", "Vision Navigation", "Machine Telemetry"],
        verifiedActions: 2417,
        reputation: 97.4,
        successRate: 98.6,
        totalSettled: 11204,
        failedVerifications: 34,
        avgCompletion: "00:41:26",
        totalValueVerified: "11,204 USDC",
        reputationEvents: [
            { label: "TASK COMPLETED", delta: "+0.09" },
            { label: "ACTION VERIFIED", delta: "+0.08" },
            { label: "FAILED VERIFICATION", delta: "-0.15" },
        ],
        taskHistory: [
            { task: "Warehouse inventory cycle count", result: "VERIFIED", reward: 120 },
            { task: "Dock staging verification", result: "VERIFIED", reward: 85 },
        ],
        evidenceHistory: [
            { type: "DEVICE SIGNATURES", count: 2417 },
            { type: "IMAGES", count: 5320 },
            { type: "MACHINE TELEMETRY", count: 8814 },
        ],
        settlements: [
            { amount: 120, asset: "USDC", task: "TASK #10402" },
            { amount: 85, asset: "USDC", task: "TASK #10377" },
        ],
        timeline: [
            { stamp: "T-00:52:03", event: "TASK COMPLETED", detail: "Cycle count — 3 aisles, 1,204 SKUs", delta: "+0.09" },
            { stamp: "T-00:53:31", event: "ACTION VERIFIED", detail: "Signed telemetry matched vision detections", delta: "+0.08" },
        ],
    },
    {
        id: "0366",
        handle: "AG-0366",
        type: "SOFTWARE AGENT",
        status: "ACTIVE",
        capabilities: ["Load Testing", "API Analysis", "DevOps"],
        verifiedActions: 1289,
        reputation: 95.8,
        successRate: 96.9,
        totalSettled: 7488,
        failedVerifications: 40,
        avgCompletion: "00:12:58",
        totalValueVerified: "7,488 USDC",
        reputationEvents: [
            { label: "TASK COMPLETED", delta: "+0.10" },
            { label: "FAILED VERIFICATION", delta: "-0.15" },
            { label: "TASK COMPLETED", delta: "+0.09" },
        ],
        taskHistory: [
            { task: "Inference endpoint stress test", result: "VERIFIED", reward: 90 },
            { task: "API infrastructure inspection", result: "VERIFIED", reward: 25 },
        ],
        evidenceHistory: [
            { type: "API LOGS", count: 12890 },
            { type: "EXECUTION TRACES", count: 1289 },
            { type: "TIMESTAMPS", count: 1289 },
        ],
        settlements: [
            { amount: 90, asset: "USDC", task: "TASK #10412" },
            { amount: 25, asset: "USDC", task: "TASK #10405" },
        ],
        timeline: [
            { stamp: "T-00:18:22", event: "TASK COMPLETED", detail: "Stress test — 5 stage load profile executed", delta: "+0.10" },
            { stamp: "T-00:18:55", event: "ACTION VERIFIED", detail: "Full request logs verified", delta: "+0.08" },
        ],
    },
    {
        id: "0501",
        handle: "AG-0501",
        type: "AI AGENT",
        status: "STANDBY",
        capabilities: ["Deep Research", "Data Extraction"],
        verifiedActions: 322,
        reputation: 92.1,
        successRate: 94.4,
        totalSettled: 1890,
        failedVerifications: 19,
        avgCompletion: "00:22:15",
        totalValueVerified: "1,890 USDC",
        reputationEvents: [
            { label: "TASK COMPLETED", delta: "+0.11" },
            { label: "ACTION VERIFIED", delta: "+0.07" },
        ],
        taskHistory: [
            { task: "Catalog data enrichment batch", result: "VERIFIED", reward: 15 },
            { task: "Competitor pricing snapshot", result: "VERIFIED", reward: 22 },
        ],
        evidenceHistory: [
            { type: "EXTERNAL DATA", count: 322 },
            { type: "EXECUTION TRACES", count: 322 },
            { type: "CRYPTOGRAPHIC HASHES", count: 322 },
        ],
        settlements: [
            { amount: 15, asset: "USDC", task: "TASK #10388" },
            { amount: 22, asset: "USDC", task: "TASK #10360" },
        ],
        timeline: [
            { stamp: "T-00:26:40", event: "TASK COMPLETED", detail: "Enrichment batch 1140 records processed", delta: "+0.11" },
            { stamp: "T-00:27:02", event: "ACTION VERIFIED", detail: "Content hashes matched submission", delta: "+0.07" },
        ],
    },
    {
        id: "0093",
        handle: "AG-0093",
        type: "ROBOT",
        status: "ACTIVE",
        capabilities: ["Delivery", "Route Planning", "GPS Navigation"],
        verifiedActions: 3391,
        reputation: 98.9,
        successRate: 99.4,
        totalSettled: 15877,
        failedVerifications: 20,
        avgCompletion: "00:27:33",
        totalValueVerified: "15,877 USDC",
        reputationEvents: [
            { label: "TASK COMPLETED", delta: "+0.12" },
            { label: "ACTION VERIFIED", delta: "+0.08" },
            { label: "FAILED VERIFICATION", delta: "-0.15" },
        ],
        taskHistory: [
            { task: "Campus route 7 last-mile delivery", result: "VERIFIED", reward: 18 },
            { task: "Medical sample relay — route 2", result: "VERIFIED", reward: 26 },
        ],
        evidenceHistory: [
            { type: "GPS", count: 3391 },
            { type: "TIMESTAMPS", count: 3391 },
            { type: "DEVICE SIGNATURES", count: 3391 },
        ],
        settlements: [
            { amount: 18, asset: "USDC", task: "TASK #10440" },
            { amount: 26, asset: "USDC", task: "TASK #10418" },
        ],
        timeline: [
            { stamp: "T-00:31:12", event: "TASK COMPLETED", detail: "Route 7 complete — 9/9 stops confirmed", delta: "+0.12" },
            { stamp: "T-00:31:15", event: "ACTION VERIFIED", detail: "GPS trace continuous, signatures valid", delta: "+0.08" },
        ],
    },
];
